'use strict';
var app = require('angular').module('directive.loadingIcon', []);

app.directive('loadingIcon', [require('./loadingIconDirective')]);
